import Collapse from 'bootstrap/js/dist/collapse';
import Mark from 'mark.js';
import { debounce } from '@/scripts/utils/debounce';

document.addEventListener('DOMContentLoaded', function () {
    // search in faqs

    // get form and search items
    const searchForm = document.querySelector('#faqSearchForm');
    const searchInput = searchForm?.querySelector('.faqSearchForm__input');
    const faqSection = document.querySelector('.faq-section-wrapper');
    const searchItems = document.querySelectorAll('.faq-item');
    const noResults = document.querySelector('#faqNoResults');

    if (!searchForm || !searchInput || !searchItems) return;

    // handle search when form is submitted or search is triggered
    // search (unlike submit) is triggered when native clear button
    // in the search input is clicked 
    searchForm.addEventListener('submit', function (e) {
        e.preventDefault();
        handleSearch();
        // scroll to content container
        faqSection?.scrollIntoView();
    });
    searchInput.addEventListener('search', handleSearch);
    // debounce search when input triggered (for performance)
    searchInput.addEventListener('input', debounce(handleSearch));

    function handleSearch() {
        // get search value
        const searchValue = searchInput.value;

        // mark results
        markResults(searchValue);

        // get all collapses
        let allCollapses = document.querySelectorAll('.collapse');

        // only if search is empty
        if (!searchValue.length) {
            for (const element of allCollapses) {
                // get collapses
                let collapseInstance = Collapse.getOrCreateInstance(element, {
                    toggle: false
                });

                // show wrapper collapses, hide content collapses
                if (element.classList.contains('faq-group-item-wrapper') || element.classList.contains('faq-item-wrapper')) {
                    collapseInstance.show();
                }
                else {
                    collapseInstance.hide();
                }
            }

            return;
        }

        for (const element of allCollapses) {
            // init or get instance, don't toggle at init
            let collapseInstance = Collapse.getOrCreateInstance(element, {
                toggle: false
            });

            // if it has highlighted parts, show it
            // otherwise, hide it
            if (element.querySelector('mark.searchMark')) {
                collapseInstance.show();
            }
            else {
                collapseInstance.hide();
            }
        }
    }

    function markResults(searchString) {
        let markInstance = new Mark(searchItems);
        // delete all marks from previous iteration
        markInstance.unmark();

        // set up marks
        markInstance.mark(searchString, {
            element: 'mark',
            className: 'searchMark',
            separateWordSearch: false,
            accuracy: 'partially',
            diacritics: true,
            caseSensitive: false,
            ignoreJoiners: true,
            acrossElements: true,
            // noMatch: term => {
            //     console.log(term);
            // },
            done: matchCount => {
                if (!matchCount && searchInput.value.length) {
                    noResults?.classList.add('show');
                }
                else {
                    noResults?.classList.remove('show');
                }
            }
        });
    }
});